const TablePosition = require('../TablePosition')

/**
 * Delete the whole table
 *
 * @param {Object} opts
 * @param {Slate.Transform} transform
 * @param {Number} at
 * @return {Slate.Transform}
 */
function removeTable (opts, transform, at) {
  const { state } = transform
  const { startBlock } = state

  const pos = TablePosition.create(state, startBlock, opts)
  const { table } = pos

  return transform
        .deselect()
        .removeNodeByKey(table.key)
}

module.exports = removeTable



// WEBPACK FOOTER //
// ./src/components/DeepTableSlatePlugin/deep-table-plugin/transforms/removeTable.js